import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const BlacklistGrandesVolumesEdit =

withRouter(

// redux
connect(
	null,
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				entrada: {
					padrao: "",
					observacao: "",
				},
				botoesHabilitados: true,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.salvar = this.salvar.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />

					<div style={{margin: "10px"}}>
						<h1>Cadastro de Blacklist de Arquivos de Grandes Volumes</h1>
					</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount() {
			this.props.limpaMensagem();
		}

		renderForm() {
			const { entrada } = this.state;

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="padrao">Padrão (glob):</label>
										<input type="text" name="padrao"
											value={entrada.padrao}
											onChange={this.handleInputChange}
											placeholder="ex: FT10980*, *.tmp"
											maxLength="100"/>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="observacao">Observação:</label>
										<textarea name="observacao"
											value={entrada.observacao}
											onChange={this.handleInputChange}
											maxLength="255"/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>Incluir</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.value;

			const entrada = this.state.entrada;
			entrada[nome] = valor;
			this.setState({ entrada });
		}

		validaFormulario(){
			let mensagens = [];
			const { padrao } = this.state.entrada;

			if (!padrao || padrao.trim().length === 0) {
				mensagens.push({mensagem: "Padrão é obrigatório."});
			}

			if (mensagens.length > 0) {
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens);
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados: false});

			const { padrao, observacao } = this.state.entrada;
			const data = { padrao, observacao };

			this.props.mostraAguardando();
			api.post('/api/blacklist-arquivo-gv', data)
				.then(() => {
					this.props.exibeMensagemSucesso("Entrada de blacklist incluída com sucesso.");
					this.setState({
						entrada: {
							padrao: "",
							observacao: "",
						},
					});
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível incluir a entrada de blacklist.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados: true});
				});
		}
	}

) // redux
); // router
